import { render, staticRenderFns } from "./addMaterialRequisitionDetail.vue?vue&type=template&id=18d4f83e&scoped=true&"
import script from "./addMaterialRequisitionDetail.vue?vue&type=script&lang=js&"
export * from "./addMaterialRequisitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./addMaterialRequisitionDetail.vue?vue&type=style&index=0&id=18d4f83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4f83e",
  null
  
)

export default component.exports